import { render } from "./PageNotFound.vue?vue&type=template&id=5a064678&scoped=true"
import script from "./PageNotFound.vue?vue&type=script&lang=js"
export * from "./PageNotFound.vue?vue&type=script&lang=js"

import "./PageNotFound.vue?vue&type=style&index=0&id=5a064678&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a064678"]])

export default __exports__